import { z } from 'zod';

export const MatchViewModelSchema = z.object({
    games: z.array(
        z.object({
            home_points: z.number(),
            guest_points: z.number(),
        })
    ),
    mode: z.union([z.literal(0), z.literal(1)]),
    mode_string: z.string(),
    player_home: z.array(z.string()),
    player_guest: z.array(z.string()),
    home_team: z.string(),
    guest_team: z.string(),
    player_positioning: z.array(z.array(z.number())),
    serving_team: z.number(),
    server: z.number().optional(), // legacy, needed for backward compatibility
    receiver: z.number().optional(), // legacy, needed for backward compatibility
});

export type MatchViewModel = z.infer<typeof MatchViewModelSchema>;
